






































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import listMixins from '@/mixins/list'
import { columns } from './questionnaire/config'
import RevisitApi from '@/api/revisit'

@Component({
	name: 'returnVisitQuestionnaire',
	components: {
		PageLayout,
	},
})
export default class TasksList extends Mixins(listMixins) {
	private columns: any = columns
	private data: any[] = []

	private toggleActive(id: string) {
		RevisitApi.changeTemplateStatus(id).then((res: any) => {
			this.getList()
		})
	}

	private deleteQuestionnaire(row: any) {
		if (row.companyList && row.companyList.length > 0) {
			return this.$message.error('删除失败，该问卷有机构正在使用，请调整后重试')
		} else {
			this.$confirm({
				title: '提示',
				content: '请确定是否删除该问卷',
				onOk: () => {
					RevisitApi.deleteTemplate(row.id).then((res: any) => {
						this.$message.success(res.message || '删除成功')
						this.getList()
					})
				},
				onCancel() {},
			})
		}
	}

	private go2Edit(id: string) {
		this.$multiTab.close('/returnVisit/editQuestionnaire')
		this.$ls.set('questionnaireId', id)
		this.$nextTick(() => {
			// 需放在nextTick中，防止同步执行后页面不重新渲染
			this.$multiTab.open(`/returnVisit/editQuestionnaire`)
		})
	}

	public getList() {
		return RevisitApi.getQuestionnaireList({
			pageSize: this.pageSize,
			pageNum: this.current,
		}).then((res: any) => {
			this.data = res.data.retList
			this.total = res.data.count
		})
	}

	public activated() {
		this.getList()
	}
}
